import {
    GOOGLE_PAY_PAYMENT,
    GOOGLE_PAY_PAYMENT__FAILURE,
    GOOGLE_PAY_PAYMENT__RESET,
} from './actions';

const initialState = {
    googlePayment: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
};
export default function GoogleReducer(state = initialState, action = {}) {
    switch (action.type) {
        case GOOGLE_PAY_PAYMENT: {
            return {
                ...state,
                googlePayment: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case GOOGLE_PAY_PAYMENT__FAILURE: {
            return {
                ...state,
                googlePayment: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        case GOOGLE_PAY_PAYMENT__RESET: {
            return {
                ...state,
                googlePayment: {
                    ...initialState.googlePayment,
                },
            };
        }

        default: {
            return state;
        }
    }
}
